var map = {
	"./black/kaishihuiyi.png": "4MFf",
	"./blue/kaishihuiyi.png": "N20H",
	"./white/kaishihuiyi.png": "r3Xt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mIK5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/kaishihuiyi\.png$
// module id = mIK5
// module chunks = 24